Board = require 'models/board'
CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'
Util = require 'lib/util'

module.exports = class BoardList extends CollectionWithHelpers
  model: Board

  initialize: ->
    @listenTo @, 'change:name', @sort
    return

  comparator: (board) ->
    # Sort by org name, then board name

    org = board.getOrganization()
    orgName = org?.get('displayName') || ""
    boardName = board.get('name') || ""
    Util.rpad(orgName, 64).toUpperCase() + boardName.toUpperCase()



// WEBPACK FOOTER //
// ./app/scripts/models/collections/board-list.coffee